var calObj = new Array();

/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

calObj[0] = new Object();

// 曜日スタート // [0] 日 / [1] 月 / [2] 火 / [3] 水 / [4] 木 / [5] 金 / [6] 土
calObj[0].weekStart = 1;
// xヶ月後のカレンダーを初期表示するか (0の場合は当月)
calObj[0].defaultMonth = 0;
// ["day"] 日付に対してのクラス指定
calObj[0].daysClass = new Object();

// ["week"] 毎週○曜日の場合
calObj[0].week = new Array();
calObj[0].week[0] = "Business"; // Sun
calObj[0].week[1] = ""; // Mon
calObj[0].week[2] = ""; // Tue
calObj[0].week[3] = ""; // Wed
calObj[0].week[4] = ""; // Thu
calObj[0].week[5] = ""; // Fri
calObj[0].week[6] = "Business"; // Sat

// (○月) 第× △曜日の場合
calObj[0].month = new Object();

// ["backward"] 過去の日付のクラス名(指定しない場合はnull)
calObj[0].backward = 'backward';

// カレンダーをクリックできるようにする場合 (有効 : true / 無効 : false)
// クラス指定でURLが指定されている場合はそっちが優先されます。
calObj[0].click = false;

// 優先度 クラス指定する順番が変わります。
calObj[0].priority = new Array('week', 'day', 'backward');


/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

// 以下、さわらぬ神にたたりなし
calObj.calendars = new Array();
calObj.days = new Array(0, 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31);
calObj.weekName = new Array("日", "月", "火", "水", "木", "金", "土");
calObj.monthName = new Array('', '1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月');
calObj.date = new Date();
calObj.date = new Date(calObj.date.getFullYear() + "/" + (calObj.date.getMonth() + 1) + "/" + calObj.date.getDate() + " 00:00:00");
calObj.day = calObj.date.getDate();
calObj.month = calObj.date.getMonth() + 1;
calObj.year = calObj.date.getFullYear();
calObj.currentList = null;

function cal_init() {
    var d = window.document;
    var tagObj = d.getElementsByTagName("div");
    for (var i = 0; i < tagObj.length; i++) {
        if (tagObj[i].className == "cal_wrapper") {
            var calId = Number(tagObj[i].id.substring(3, tagObj[i].id.length));
            calObj.calendars.push(calId);
            if (0 < (calObj.month + calObj[calId].defaultMonth) && (calObj.month + calObj[calId].defaultMonth) < 13) {
                calObj[calId].currentMonth = new Date(calObj.year + "/" + (calObj.month + calObj[calId].defaultMonth) + "/" + "1 00:00:00");
            } else {
                calObj[calId].currentMonth = new Date((calObj.year + 1) + "/" + ((calObj.month + calObj[calId].defaultMonth) % 12) + "/" + "1 00:00:00");
            }
            cal_create(calId);
        }
    }
}

function cal_create(calId) {
    var d = window.document;
    var month = calObj[calId].currentMonth.getMonth() + 1;
    var year = calObj[calId].currentMonth.getFullYear();
    var week = calObj[calId].currentMonth.getDay();
    var time = calObj[calId].currentMonth.getTime();
    var tdTextListArr = new Array();
    var bisDay = 0;
    var WeekCnt = new Array();
    if (month == 2) {
        if (year % 100 == 0 || year % 4 != 0) {
            if (year % 400 != 0) {
                bisDay = 0;
            } else {
                bisDay = 1;
            }
        } else if (year % 4 == 0) {
            bisDay = 1;
        } else {
            bisDay = 0;
        }
    }
    var calHTML = "<table border='0' cellspacing='0' cellpadding='0' class='cal'>";
    calHTML += "<tr><th colspan='7'>";
    calHTML += "<div class='cal_ui'>";
    calHTML += "<input type='button' onclick='cal_move(" + calId + ",-1);' value='&lt; 先月' />";
    calHTML += "<input type='button' onclick='cal_move(" + calId + ",null);' value='-' />";
    calHTML += "<input type='button' onclick='cal_move(" + calId + ",1);' value='翌月 &gt;' />";
    calHTML += "</div>";
    calHTML += "<p>" + year + "年" + calObj.monthName[month] + "</p></th></tr>";
    calHTML += "<tr class='headline'>";
    for (var i = 0; i < 7; i++) {
        var w = (calObj[calId].weekStart + i) % 7;
        calHTML += "<td>" + calObj.weekName[w] + "</td>";
    }
    calHTML += "</tr><tr>";
    var weekBreak = (calObj[calId].weekStart - 1) % 7;
    if (weekBreak < 0) {
        weekBreak = 6;
    }
    var ws = week;
    var i = 0;
    var weekBlank = [];
    while (ws != calObj[calId].weekStart) {
        var t = new Date(time - ((i + 1) * (60 * 60 * 24 * 1000)));
        weekBlank.unshift('<td><div class="backward">' + t.getDate() + "</div></td>");
        i++;
        ws--;
        if (ws < 0) {
            ws = 6;
        }
    }
    calHTML += weekBlank.join('');

    for (dayCnt = 1; dayCnt <= (calObj.days[month] + bisDay); dayCnt++) {
        var dayStr = year + "/" + month + "/" + dayCnt;
        var dayStrN = month + "/" + dayCnt;
        if (WeekCnt[week] == undefined) {
            WeekCnt[week] = 0;
        }
        WeekCnt[week]++;

        var monStr = '' + month + '-' + week + '-' + WeekCnt[week];
        var weekStr = '' + week + '-' + WeekCnt[week];

        var dayClass = new Object();
        var currentDayDate = new Date(year + "/" + month + "/" + dayCnt + " 00:00:00");
        var tdId = "td_" + calId + "_" + year + "_" + month + "_" + dayCnt;

        // backward
        if (calObj[calId].backward != null && currentDayDate.getTime() < calObj.date.getTime()) {
            dayClass["backward"] = calObj[calId].backward;
        }

        // week
        if (calObj[calId].month[weekStr] != undefined) {
            dayClass["week"] = calObj[calId].month[weekStr];
        } else if (calObj[calId].month[monStr] != undefined) {
            dayClass["week"] = calObj[calId].month[monStr];
        } else if (calObj[calId].week[week] != undefined) {
            if (typeof (calObj[calId].week[week]) == "object" && calObj[calId].week[week][WeekCnt[week]] != undefined) {
                dayClass["week"] = calObj[calId].week[week][WeekCnt[week]];
            } else if (calObj[calId].week[week] != undefined && typeof (calObj[calId].week[week]) != "object") {
                dayClass["week"] = calObj[calId].week[week];
            }
        }

        // day
        if (calObj[calId].daysClass[dayStr] != undefined) {
            dayClass["day"] = calObj[calId].daysClass[dayStr];
        } else if (calObj[calId].daysClass[dayStrN] != undefined) {
            dayClass["day"] = calObj[calId].daysClass[dayStrN];
        }

        var tdClassArr = new Array();
        var tdTextArr = new Array();
        var tdClassStr = "";
        var tdTextStr = "";
        var tdMouse = "";
        var tdClassNames = new Object();
        for (var ci = 0; ci < calObj[calId].priority.length; ci++) {
            if (dayClass[calObj[calId].priority[ci]] != undefined) {
                var splitArr = new Array();
                splitArr = dayClass[calObj[calId].priority[ci]].split(';');
                tdClassArr.push(splitArr[0]);
                tdClassNames[splitArr[0]] = true;
                if (splitArr[1] != undefined) {
                    tdTextArr.push(splitArr[1]);
                    var tdTextListLink = "";
                    if (splitArr[2] != undefined)
                        tdTextListLink = " onclick=\"cal_open(\'" + splitArr[2] + "\')\"";
                    tdTextListArr.push('<ol><li id="' + tdId + '_li" onmouseover="cal_list2day_over(this)" onmouseout="cal_list2day_out(this)" value="' + dayCnt + '"' + tdTextListLink + '>' + splitArr[1] + '</li></ol>');
                }
                if (splitArr[2] != undefined) {
                    tdLinkArr.push(splitArr[2]);
                }
            }
        }
        if (tdTextArr.length > 0) {
            tdTextStr = "<span id='" + tdId + "'>";
            for (var i = 0; i < tdTextArr.length; i++) {
                tdTextStr += tdTextArr[i] + "<br />";
            }
            tdTextStr += "</span>";
            tdClassArr.push('pointer');
        }
        if (tdClassArr.length > 0)
            tdClassStr = " class='" + tdClassArr.join(' ') + "'";
        calHTML += "<td id='" + tdId + "_td'><div" + tdClassStr + tdMouse + ">" + dayCnt + tdTextStr + "</div></td>";
        if (week == weekBreak) {
            calHTML += "</tr>";
            if (dayCnt < calObj.days[month]) {
                calHTML += "<tr>";
            }
        }
        week++;
        week = week % 7;
    }
    var nd = 0;
    while (week != calObj[calId].weekStart) {
        nd++;
        calHTML += '<td><div class="backward">' + nd + '</div></td>';
        week++;
        week = week % 7;
    }
    calHTML += "</table>";
    d.getElementById('cal' + calId).innerHTML = calHTML;

    // list
    if (d.getElementById('schedule' + calId)) {
        d.getElementById('schedule' + calId).innerHTML = "";
        if (tdTextListArr.length > 0 && d.getElementById('schedule' + calId)) {
            d.getElementById('schedule' + calId).innerHTML = tdTextListArr.join('');
        }
    }
    // /list
}

function cal_list2day_over(obj) {
    var d = window.document;
    var dayId = obj.id.substring(0, obj.id.indexOf('_li'));
    if (d.getElementById(calObj.currentList)) {
        d.getElementById(calObj.currentList).style.backgroundColor = '#FFF';
    }
    calObj.currentList = dayId + '_td';
    if (d.getElementById(dayId + '_td')) {
        d.getElementById(dayId + '_td').style.backgroundColor = '#CCC';
    }
}

function cal_list2day_out(obj) {
    var d = window.document;
    if (d.getElementById(calObj.currentList)) {
        d.getElementById(calObj.currentList).style.backgroundColor = '#FFF';
    }
}

function cal_open(uri) {
    window.open(uri);
}

function cal_move(calId, m) {
    if (m == null) {
        calObj[calId].currentMonth = new Date(calObj.year + "/" + (calObj.month) + "/" + "1 00:00:00");
    } else {
        var month = calObj[calId].currentMonth.getMonth() + 1;
        var year = calObj[calId].currentMonth.getFullYear();
        if (0 < month + m && month + m < 13)
            calObj[calId].currentMonth = new Date(year + "/" + (month + m) + "/" + "1 00:00:00");
        else if ((month + m) < 1) {
            year--;
            month = 12;
            calObj[calId].currentMonth = new Date(year + "/" + (month) + "/" + "1 00:00:00");
        } else {
            year++;
            month = 1;
            calObj[calId].currentMonth = new Date(year + "/" + (month) + "/" + "1 00:00:00");
        }
    }
    cal_create(calId);
}

const API_KEY = 'AIzaSyCHxS6dQSAKFuLMDnMhcvV3Lek-S9CRmZQ'
const CALENDAR_ID = 'ja.japanese#holiday@group.v.calendar.google.com';
const CALENDAR_ID2 = 'lacitashop2021@gmail.com';

var business_days = [];

function start() {
    gapi.client.init({
        'apiKey': API_KEY,
    }).then(function () {
        return gapi.client.request({
            'path': 'https://www.googleapis.com/calendar/v3/calendars/' + encodeURIComponent(CALENDAR_ID) + '/events'
        })
    }).then(function (response) {
        let items = response.result.items;
        for (let i = 0; i < items.length; i++) {
            business_days.push(items[i].start.date);
        }

        gapi.client.init({
            'apiKey': API_KEY,
        }).then(function () {
            return gapi.client.request({
                'path': 'https://www.googleapis.com/calendar/v3/calendars/' + encodeURIComponent(CALENDAR_ID2) + '/events'
            })
        }).then(function (response) {
            let items = response.result.items;
            for (let i = 0; i < items.length; i++) {
                business_days.push(items[i].start.date);
            }
            business_days.sort(
                function (a, b) {
                    return (a < b ? 1 : -1);
                }
            );
            var days_sort = $.unique(business_days);
            $.each(days_sort, function (index, value) {
                var d = new Date(value);
                calObj[0].daysClass[d.getFullYear() + "/" + (d.getMonth() + 1) + "/" + d.getDate()] = 'Holyday';
            })
            cal_init();

        }, function (reason) {
            console.log('Error: ' + reason.result.error.message);
        });
    }, function (reason) {
        console.log('Error: ' + reason.result.error.message);
    });
};

gapi.load('client', start)

